module.exports = __webpack_public_path__ + "media/images/img_adviser_popup_banner-dce09c15869121476c0e81c6cbbb151b.png";